import { Injectable, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { StorageMap } from '@ngx-pwa/local-storage';
import {
  SoundNotification,
  StafferSettingsStoreService,
} from '@principle-theorem/ng-principle-shared';
import {
  BasicDialogService,
  DialogPresets,
} from '@principle-theorem/ng-shared';
import {
  IChat,
  IChatMessage,
} from '@principle-theorem/principle-core/interfaces';
import {
  DocumentReference,
  shareReplayHot,
  WithRef,
} from '@principle-theorem/shared';
import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { FloatingChatComponent } from './components/floating-chat/floating-chat.component';

export const DEFAULT_CHAT_SOUND = '/assets/sounds/notification.mp3';

@Injectable({
  providedIn: 'root',
})
export class ChatNotificationsService implements OnDestroy {
  private _onDestroy$ = new Subject<void>();
  private _openChatRefs: MatDialogRef<unknown>[] = [];
  private _soundNotification: SoundNotification;

  notificationSound$: Observable<string>;

  constructor(
    private _dialog: BasicDialogService,
    private _staffer: StafferSettingsStoreService,
    storage: StorageMap
  ) {
    this.notificationSound$ = this._staffer.chats$.pipe(
      map(
        (chatSettings) =>
          chatSettings.notificationSoundOverride ?? DEFAULT_CHAT_SOUND
      ),
      shareReplayHot(this._onDestroy$)
    );

    this._soundNotification = new SoundNotification(
      'chats',
      this.notificationSound$,
      storage,
      this._onDestroy$
    );
  }

  ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  async triggerNotificationMessage(
    _message: WithRef<IChatMessage>
  ): Promise<void> {
    await this._soundNotification.triggerNotification();
  }

  showPopupChat(chatRef: DocumentReference<IChat>): void {
    this._openChatRefs.map((ref) => {
      try {
        ref.close();
      } catch {
        // Do nothing
      }
    });

    this._openChatRefs = [];

    const dialogRef = this._dialog.open<
      FloatingChatComponent,
      DocumentReference<IChat>
    >(
      FloatingChatComponent,
      DialogPresets.flex({
        width: '368px',
        position: {
          bottom: '20px',
          right: '20px',
        },
        data: chatRef,
        hasBackdrop: false,
      })
    );

    this._openChatRefs.push(dialogRef);
  }
}
